/* Printado cookiebanner: toestemming opslaan en doorgeven aan Google Consent Mode en Shopify. */
(function () {
  var KEY = 'printado_consent', MAX = 365 * 864e5;
  var el = document.getElementById('ck'); if (!el) return;
  var opts = el.querySelector('[data-ck-opts]'), saveBtn = el.querySelector('[data-ck-save]'), tog = el.querySelector('[data-ck-toggle]');
  var boxes = { analytics: el.querySelector('[data-ck="analytics"]'), marketing: el.querySelector('[data-ck="marketing"]') };

  function read() { try { var v = JSON.parse(localStorage.getItem(KEY)); if (v && Date.now() - v.t < MAX) return v; } catch (e) {} return null; }
  function apply(c) {
    if (typeof window.gtag === 'function') {
      var a = c.analytics ? 'granted' : 'denied', m = c.marketing ? 'granted' : 'denied';
      window.gtag('consent', 'update', { analytics_storage: a, ad_storage: m, ad_user_data: m, ad_personalization: m });
    }
    try {
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err && Shopify.customerPrivacy) Shopify.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: true, sale_of_data: !!c.marketing }, function () {});
        });
      }
    } catch (e) {}
  }
  function save(c) {
    c.t = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
    apply(c); el.hidden = true;
  }
  function open(showOpts) {
    var c = read() || {};
    boxes.analytics.checked = !!c.analytics; boxes.marketing.checked = !!c.marketing;
    opts.hidden = !showOpts; saveBtn.hidden = !showOpts; tog.hidden = showOpts;
    el.hidden = false;
  }

  el.querySelector('[data-ck-all]').addEventListener('click', function () { save({ analytics: true, marketing: true }); });
  el.querySelector('[data-ck-none]').addEventListener('click', function () { save({ analytics: false, marketing: false }); });
  tog.addEventListener('click', function () { open(true); });
  saveBtn.addEventListener('click', function () { save({ analytics: boxes.analytics.checked, marketing: boxes.marketing.checked }); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-cookie-open]')) { e.preventDefault(); open(true); } });

  var stored = read();
  if (stored) apply(stored); else open(false);
})();
